import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 100vw;
  height: 100vh;
  background: black;
  overflow: hidden;

  .error-validation {
    font-family: Roboto, sans-serif;
    font-size: 1.4rem;
    color: red;
  }

  .background-image {
    z-index: 999;
  }

  .span-text {
    font-family: Roboto, sans-serif;
    font-weight: 400;
    font-size: 1.8rem;
    color: #555454;

    align-items: center;
    text-align: center;
    margin-bottom: 6.8rem;

    @media (max-width: 1600px) {
      font-size: 1.6rem;
      margin-top: 2rem;
      margin-bottom: -1rem;
    }

    @media (max-width: 1366px) {
      font-size: 1.4rem;
      margin-top: 1rem;
      margin-bottom: 2rem;
    }
  }

  @media (max-width: 1366px) {
    .error-validation {
      font-size: 0.8rem;
      margin-top: -1rem;
    }

    .background-image {
      width: 300px;
    }
  }
`;

export const LeftWrapper = styled.aside`
  display: flex;
  width: 38.95%;
  height: 100%;
  background: linear-gradient(0deg, #000000 0%, #663399 100%);
  position: relative;
  align-items: center;
  justify-content: center;
`;

export const RightWrapper = styled.main`
  display: flex;
  flex: 1;
  height: 100%;
  background: white;
  z-index: 20;
  align-items: center;
  margin: 0 auto;
  justify-content: center;

  @media (max-width: 1600px) {
    padding-bottom: 3rem;
  }
`;

export const GroupDecorationLogoIV = styled.div`
  opacity: 0.2;
  position: absolute;
  width: 100%;
  height: 160px;
  display: flex;
  left: -10%;
  bottom: 53%;
  justify-content: space-around;
  z-index: 0;
  .decoration-logo {
    margin-right: 4rem;
  }

  @media (max-width: 1600px) {
    bottom: 57%;
    left: 15%;
  }

  @media (max-width: 1366px) {
    bottom: 50%;
    left: 12%;
    .decoration-logo {
      width: 70%;
      height: 70%;
    }
  }
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: auto;
  align-items: center;

  @media (max-width: 1600px) {
    .logo-uxdoc-register {
      width: 38%;
      height: 38%;
    }
  }

  @media (max-width: 1366px) {
    .logo-uxdoc-register {
      width: 32%;
      height: 32%;
    }
  }
`;

export const Heading = styled.h1`
  font-size: 3.2rem;
  color: ${({ theme }) => theme.colors.background};
  font-family: Raleway, sans-serif;
  font-weight: 600;
  margin-bottom: 3.5rem;

  @media (max-width: 1600px) {
    font-size: 3rem;
    margin-top: 4rem;
  }

  @media (max-width: 1366px) {
    font-size: 2.6rem;
    margin-top: 4.6rem;
    margin-bottom: 1rem;
  }
`;

export const DescriptionLabel = styled.p`
  font-size: 2.6rem;
  color: white;
  font-family: "Raleway", sans-serif;
  font-weight: 200;
  text-align: center;
  line-height: 180%;
  margin-top: -0.5rem;
  margin-bottom: 2rem;
  letter-spacing: 1px;

  @media (max-width: 1600px) {
    line-height: 140%;
    font-size: 2.2rem;
    min-width: 400px;
  }

  @media (max-width: 1366px) {
    line-height: 135%;
    font-size: 1.6rem;
    min-width: 360px;
    margin-top: -1rem;
  }
`;

export const VerticalStack = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 852px;
  height: 100%;
  align-items: center;
  justify-content: center;

  @media (max-width: 1366px) {
    max-width: 592px;
  }
`;

export const ButtonEntry = styled.button`
  min-width: 423px;
  height: 58px;
  background: black;
  color: white;
  border-radius: 5px;
  margin: 3.5rem auto 0 auto;
  font-size: 2rem;
  font-family: Roboto, sans-serif;
  font-weight: bold;
  cursor: pointer;
  z-index: 200;
  -webkit-box-shadow: -1px 1px 16px -8px rgba(0, 0, 0, 0.23);
  box-shadow: -1px 1px 16px -8px rgba(0, 0, 0, 0.23);
  transition: all 120ms linear;

  :hover {
    background-color: ${({ theme }) => theme.colors.background};
    -webkit-box-shadow: -1px 1px 6px -1px rgba(0, 0, 0, 0.2);
    box-shadow: -1px 1px 6px -1px rgba(0, 0, 0, 0.2);
  }

  @media (max-width: 1600px) {
    min-width: 400px;
    height: 50px;
    font-size: 1.6rem;
  }

  @media (max-width: 1600px) {
    min-width: 320px;
    height: 42px;
    font-size: 1.4rem;
    margin-top: 2.5rem;
  }
`;

export const CreateAccountContent = styled.form`
  display: flex;
  max-width: 672px;
  width: 100%;
  height: 100vh;

  flex-direction: column;

  .label-required {
    color: #555454;
    font-size: 1.5rem;
    font-family: Roboto, sans-serif;
    font-weight: 400;
    font-style: italic;
    margin-top: 1.2rem;
  }

  @media (max-width: 1600px) {
    max-width: 532px;
  }

  @media (max-width: 1366px) {
    max-width: 432px;
  }
`;

export const Title = styled.h1`
  font-family: Raleway, sans-serif;
  color: ${({ theme }) => theme.colors.background};
  font-size: 3rem;
  font-weight: 600;

  @media (max-width: 1600px) {
    font-size: 2.6rem;
  }

  @media (max-width: 1366px) {
    font-size: 2rem;
  }
`;

export const InputBase = styled.input`
  width: 100%;
  height: 45px;
  border: none;
  border-bottom: 1px solid #555454;
  font-size: 1.8rem;
  padding-bottom: 1rem;
  margin-bottom: 1rem;

  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0),
    inset 0 0 0 100px rgba(255, 255, 255, 1);

  transition: all 120ms linear;

  :focus {
    border-bottom: 1px solid ${({ theme }) => theme.colors.background};
  }

  @media (max-width: 1600px) {
    font-size: 1.6rem;
    padding-bottom: 1rem;
    margin-top: 1rem;
    height: 30px;
  }

  @media (max-width: 1366px) {
    height: 38px;
    font-size: 1.4rem;
    padding-bottom: 0.5rem;
    margin-top: 0.5rem !important;
    height: 30px;
  }
`;

export const Text = styled.p`
  font-family: Roboto, sans-serif;
  font-weight: 400;
  font-size: 1.6rem;
  color: #555454;
  margin-top: 0rem;
  align-items: center;
  text-align: center;
  max-width: 473px;
  line-height: 150%;
  margin-top: 1rem;
  margin-bottom: 5rem;

  @media (max-width: 1600px) {
    font-size: 1.6rem;
    margin-top: 2rem;
    margin-bottom: -1rem;
  }

  @media (max-width: 1366px) {
    font-size: 1.4rem;
    margin-top: 1rem;
    margin-bottom: 0rem;
  }
`;

export const TextInfo = styled.p`
  font-family: Roboto, sans-serif;
  font-weight: 400;
  font-size: 1.8rem;
  color: #555454;
  margin: -4rem auto 4rem auto;
  align-items: center;
  text-align: center;
  width: 460px;

  @media (max-width: 1600px) {
    font-size: 1.6rem;
    width: 360px;
    margin-top: -3rem;
    margin-bottom: 4rem;
  }

  @media (max-width: 1366px) {
    font-size: 1.4rem;
    width: 300px;
    margin-top: -4rem;
    margin-bottom: 1.4rem;
  }
`;

export const InputRadio = styled.input`
  width: 18px;
  height: 18px;
  background-color: red;
  accent-color: ${({ theme }) => theme.colors.background};
  margin-right: 1rem;
  font-size: 1.6rem;

  @media (max-width: 1366px) {
    width: 13px;
    height: 13px;
  }
`;

export const WrapperRadio = styled.div`
  display: flex;
  width: 100%;
  height: 50px;
  align-items: center;
  margin-top: 1rem;

  input[type="checkbox"] {
    accent-color: ${({ theme }) => theme.colors.background};
  }

  @media (max-width: 1600px) {
    height: 45px;
  }

  @media (max-width: 1366px) {
    height: 40px;
  }
`;

export const WrapperRadioII = styled.div`
  display: flex;
  width: 100%;
  height: 50px;
  align-items: center;
  margin-top: -1.5rem;
  @media (max-width: 1600px) {
    height: 45px;
  }
`;

export const OptionLabel = styled.p`
  font-family: Roboto, sans-serif;
  font-weight: 400;
  font-size: 1.8rem;
  color: #555454;
  align-items: center;

  @media (max-width: 1600px) {
    font-size: 1.6rem;
  }

  @media (max-width: 1366px) {
    font-size: 1.4rem;
  }
`;

export const ButtonCreateNewAccount = styled.button`
  width: 100%;
  background-color: black;
  color: white;
  height: 58px;
  border-radius: 1rem;
  font-family: Roboto, sans-serif;
  font-size: 1.8rem;
  font-weight: bold;
  margin-top: 1.5rem;
  max-width: 572px;
  transition: all 120ms linear;

  :hover {
    background-color: ${({ theme }) => theme.colors.background};
  }

  @media (max-width: 1600px) {
    min-height: 50px;
    margin-top: 0.5rem;
  }

  @media (max-width: 1366px) {
    height: 40px;
    margin-top: 3rem;
    margin-bottom: 0rem;
    font-size: 1.5rem;
  }
`;

export const Label = styled.span`
  font-family: Roboto, sans-serif;
  font-weight: 400;
  font-size: 1.6rem;
  color: #555454;
  align-items: center;
  margin-left: 1rem;

  @media (max-width: 1600px) {
    font-size: 1.4rem;
  }

  @media (max-width: 1366px) {
    font-size: 1.2rem;
  }
`;

export const InputCheckbox = styled.input`
  width: 18px;
  height: 18px;

  @media (max-width: 1366px) {
    width: 14px;
    height: 14px;
  }
`;
